import type { NavbarMenuItemType } from "@crescentapplications/react-ui";

const navbarMenuItems: NavbarMenuItemType[] = [
  {
    id: "profile",
    kind: "link",
    title: { ar: "الملف الشخصي", en: "Profile" },
    to: "/#profile",
  },
  {
    id: "lineage",
    kind: "link",
    title: { ar: "النسب", en: "Lineage" },
    to: "/#lineage",
  },
  {
    id: "education",
    kind: "link",
    title: { ar: "الدراسة", en: "Education" },
    to: "/#education",
  },
  {
    id: "work",
    kind: "link",
    title: { ar: "الخبرة المهنية", en: "Work Experience" },
    to: "/#work",
  },
  {
    id: "volunteering",
    kind: "link",
    title: { ar: "العمل التطوعي", en: "Volunteering" },
    to: "/#volunteering",
  },
];

export default navbarMenuItems;
